import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ABOUT_IMG = "https://customer-assets-4nw71qhi.emergentagent.net/job_celebrate-together-74/artifacts/1wrridud_image.png";

export function About() {
  return (
    <section id="about" className="py-24 md:py-32 lg:py-40 bg-cream">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="rounded-[2.5rem] overflow-hidden shadow-[0_40px_80px_-35px_rgba(73,53,72,0.35)] aspect-[4/5]">
              <img src={ABOUT_IMG} alt="Kay Wright, founder of Community Experiences by Kay" className="h-full w-full object-cover object-top" />
            </div>
            <div className="absolute -bottom-5 -right-4 md:-right-8 bg-coral text-cream rounded-3xl px-6 py-4 shadow-xl">
              <p className="font-poppins font-bold text-lg leading-tight">Kay Wright</p>
              <p className="text-cream/80 text-sm">Founder</p>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal>
            <Eyebrow>About Kay</Eyebrow>
            <h2 className="mt-5 font-poppins font-bold text-charcoal text-4xl md:text-5xl leading-tight tracking-tight">
              Hi, I&rsquo;m Kay.
            </h2>
            <div className="mt-6 space-y-5 text-lg md:text-xl leading-relaxed text-charcoal/75 max-w-2xl">
              <p>
                I created Community Experiences by Kay because I believe people deserve more opportunities
                to feel celebrated, connected, and remembered.
              </p>
              <p>
                I partner with senior communities to create warm, thoughtfully designed experiences that
                bring residents, families, and staff together. Professional photography preserves the
                relationships, joy, and meaningful moments that make each community special.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function ServiceArea() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="rounded-[2.5rem] bg-sky/25 p-8 md:p-12 flex flex-col md:flex-row items-start md:items-center gap-5">
            <div className="h-14 w-14 shrink-0 rounded-2xl bg-white grid place-items-center">
              <MapPin size={26} className="text-plum" />
            </div>
            <div>
              <Eyebrow>Service Area</Eyebrow>
              <p className="mt-2 font-poppins font-bold text-charcoal text-xl md:text-2xl leading-snug">
                Serving senior living communities throughout the South Bay and surrounding areas, including Hawthorne, Torrance, Redondo Beach, Hermosa Beach, Manhattan Beach, Rancho Palos Verdes, Long Beach, and nearby Los Angeles County communities within approximately 50 miles.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
